/* VaultEditComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./VaultEditRenderer");
const _ = require("lodash");

/**
 * @class VaultEditComponent
 * @extends EventEmitter
 *
 * @fires VaultEditComponent#Data
 * @fires VaultEditComponent#Error
 * @fires VaultEditComponent#Shutdown
 */

class VaultEditComponent extends EventEmitter {
    constructor(type, ety, readOnly, orgId, nibApiService, userSession, VaultsEntity, uiutils) {
        super();
        this._readOnly = readOnly;
        this._type = type;
        this._ety = ety;
        this._orgId = orgId;
        this._nibApiService = nibApiService;
        this._userSession = userSession;
        this._VaultsEntity = VaultsEntity;
        this._uiutils = uiutils;
        // this._hasRevealPerms = hasRevealPerms;
        // this._CredentialsEntity = CredentialsEntity;
        // this._typeEtys = typeEtys;
        this._labels = {
            title: this._type === "edit" ? "Edit Vault" : "Add Vault",
            saveBtn: this._type === "edit" ? "Update" : "Create",
            cancelBtn: this._type === "edit" ? "Cancel" : "Close",
        };
        if (this._ety && this._ety.vendor === "gluware") {
            this._isSeeded = true;
        }
        if (type === "create") {
            const pristineProperties = {
                id: parseInt(Math.random() * 10000, 10),
                name: "",
                connectionInformation: {},
            };
            this._ety = {
                pristineProperties: pristineProperties,
            };
        }
        console.log(this._model, this._ety);
        this._registerListeners();
        this._renderer = new Renderer(this);
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _triggerData(data) {
        /**
         * @event VaultEditComponent#Data
         * @param {Object} - entity properties.
         */
        this.emit("Data", data);
    }

    _triggerError(error) {
        /**
         * @event VaultEditComponent#Error
         * @param {*} - entity properties.
         */
        this.emit("Error", error);
    }

    _registerListeners() {}

    _unregisterListeners() {}

    _shutdown() {
        this.emit("Shutdown");
        this._unregisterListeners();

        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._renderer = null;
                this._shutdownProm = null;
                this.removeAllListeners();
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    closePopUp(userRejected) {
        if (userRejected) {
            this.rejectPopUp({userRejected: true});
        } else {
            // save code
            if (this._type === "edit") {
                this.resolvePopup(this._ety);
            } else {
                const newEty = new this._VaultsEntity(this._orgId);
                const props = Object.assign({}, _.omit(this._ety.pristineProperties, ["id"]));
                Object.keys(props).forEach((prop) => {
                    newEty[prop] = props[prop];
                });
                newEty.setVendor("cyberArk");
                newEty.setTool("pam");
                console.log(newEty);
                this.resolvePopup(newEty);
            }
        }
    }

    resolvePopup(data) {
        this._context.resolve(data);
    }

    rejectPopUp(data) {
        this._context.reject(data);
    }

    whenModelIsReady() {
        return new Promise((resolve) => {
            this._integrationsMap = this._VaultsEntity.getIntegrationsMap();
            this._vendorlabelMap = this._VaultsEntity.buildCredentialProviderLabelMap();
            console.log(this._vendorlabelMap);
            console.log(this._integrationsMap);
            return resolve();
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/
    _generateTypeJtype(selectedCredsType) {
        let jtype = {};
        jtype.credentials = {};
        jtype["credentials@Display.label"] = "Secret";
        jtype.credentials.credsType = "";
        jtype.credentials["credsType@Display.label"] = "Type";
        jtype.credentials["credsType@Required!"] = "";
        let typeOpts = {};
        this._typeEtys.forEach((ety) => {
            // TODO Must be replaced by checking @Display.multiline and  @Display.password
            typeOpts[ety.credsType] = ety.jtype;
            if (this._isClientKeyCredentialType(ety.credsType)) {
                if (
                    this._type === "create" ||
                    !this._isClientKeyCredentialType(selectedCredsType)
                ) {
                    delete typeOpts[ety.credsType]["_value@Display.password!"];
                } else {
                    delete typeOpts[ety.credsType]["_value@Display.multiline"];
                }
            }
            typeOpts[ety.credsType + "@Display.label"] = ety.displayName;
            if (this._readOnly) {
                typeOpts[ety.credsType + "@Display.readOnly"] = true;
            }
        });
        if (this._readOnly) {
            jtype.credentials["credsType@Display.readOnly"] = true;
        }
        jtype.credentials["credsType@Select.options"] = typeOpts;
        return jtype;
    }

    _isClientKeyCredentialType(credsType) {
        if (credsType === "gluwareSystemClientKey") {
            return true;
        }
        return false;
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = VaultEditComponent;
